import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

export interface FilterOptions {
  planNames: string[];
  planIntervals: string[];
}

const getFilterOptions = async (): Promise<FilterOptions> => {
  const res = await axiosInstance.get(`/api/affiliates/filter-options`);
  return res.data;
};

export const useGetFilterOptions = () => {
  return useQuery(['affiliate-filter-options'], getFilterOptions);
};
